import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Megaphone } from 'lucide-react'
import { WhatsNewScreen } from '@/screens/help/SCR-177-whats-new'

// SCR-177 What's new (help area).
export const Route = createFileRoute('/_app/help/whats-new')({
  staticData: { screen: { id: 'SCR-177', title: 'What’s new', group: 'Help', order: 3, description: 'New features and changes, newest first.', icon: Megaphone } },
  validateSearch: z.object({
    category: z.enum(['memory', 'tracing', 'connect', 'teams', 'security', 'billing', 'platform']).optional().catch(undefined),
  }),
  component: WhatsNewScreen,
})
